import { RichText, Text, Image } from '@sitecore-jss/sitecore-jss-react';
import React, { useRef } from 'react';
import ReactPlayer from 'react-player';
import useWindowSize from '../Shared/hooks/useWindowSize';
import clsx from 'clsx';

import './style.scss';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

const HeaderBannerDigitalBankingComponent = (props) => {
  if (!props?.fields || !props.params)
    return <GenericPlaceholder componentName="HeaderBannerDigitalBankingComponent" />;
  const { fields, params } = props;

  const { heading, text, image, items, youtubeId, vimeoId, video } = fields;

  //render conditions
  let videoYoutubeSource = youtubeId?.value;
  let videoVimeoSource = vimeoId?.value;
  let videoSource = video?.value?.src;
  const shoudRenderImage = !!image && !!image?.value?.src;
  const shoudRenderYoutube = !!videoYoutubeSource;
  const shoudRenderVimeo = !!videoVimeoSource && !shoudRenderYoutube;
  const shoudRenderVideo = !!videoSource && !shoudRenderVimeo && !shoudRenderYoutube;
  const shoudRenderAnyTypeOfVideo = shoudRenderYoutube || shoudRenderVimeo || shoudRenderVideo;

  //render conditions
  const shouldRenderHeading = !!heading?.value;
  const shouldRenderText = !!text?.value;
  const shouldRenderItems = Array.isArray(items) && items.length > 0;
  //returned data
  return (
    <section
      className={clsx(
        'HeaderBannerDigitalBankingComponent',
        shoudRenderImage || shoudRenderAnyTypeOfVideo ? 'withMedia' : '',
        'add-margins',
        params?.Styles
      )}
    >
      <div className="content">
        <div className="auto flex-it flex-wrap">
          <div className="part text flex-it flex-align-item-center">
            <div className="wrp">
              {shouldRenderHeading && (
                <div className="title">
                  <Text field={heading} />
                </div>
              )}
              {shouldRenderText && <RichText className="description" field={text} />}
              {shouldRenderItems && (
                <div className="items flex-it flex-wrap">
                  {items.map((item, index) => {
                    const shouldRenderIcon = item?.fields?.icon?.value;
                    const shouldRenderHeadingSub = item?.fields?.heading?.value;
                    const shouldRenderTextSub = item?.fields?.text?.value;

                    return (
                      <div className="item" key={index}>
                        {shouldRenderIcon && (
                          <div className="icon">
                            <Image field={item?.fields?.icon} />
                          </div>
                        )}
                        {shouldRenderHeadingSub && (
                          <div className="text-sub">
                            <Text field={item?.fields?.heading} />
                          </div>
                        )}
                        {shouldRenderTextSub && (
                          <RichText className="description-sub" field={item?.fields?.text} />
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>

          <div
            className={clsx(
              'part media-type flex-it flex-justify-center',
              shoudRenderImage ? 'figure-type' : ''
            )}
          >
            {!shoudRenderImage && shoudRenderAnyTypeOfVideo && <VideoComponent props={props} />}
            {shoudRenderImage && (
              <figure className="flex-it flex-align-item-center">
                <Image field={image} />
              </figure>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
const VideoComponent = ({ props }) => {
  const [width] = useWindowSize();

  const { youtubeId, vimeoId, video, videoThumbnail: thumbnail } = props?.fields;
  const playerRef = useRef();

  let videoYoutubeSource = youtubeId?.value;
  let videoVimeoSource = vimeoId?.value;
  let videoSource = video?.value?.src;

  const shoudRenderYoutube = !!videoYoutubeSource;
  const shoudRenderVimeo = !!videoVimeoSource && !shoudRenderYoutube;
  const shoudRenderVideo = !!videoSource && !shoudRenderVimeo && !shoudRenderYoutube;

  return (
    <div className="video-component">
      {shoudRenderVimeo && (
        <div className="fullscreen">
          <div className="video vimeo">
            <div className="wrapper">
              <iframe
                id="videoContainer"
                style={{ minHeight: width / 1.5 + 'px' }}
                src={`//player.vimeo.com/video/${videoVimeoSource}?autoplay=1&loop=1&title=0&byline=0&portrait=0`}
                frameBorder="0"
                allowFullScreen
                sandbox
              ></iframe>
            </div>
          </div>
        </div>
      )}

      {shoudRenderVideo && (
        <div className={`videoItem videop`}>
          {
            <ReactPlayer
              url={videoSource}
              loop={false}
              controls={true}
              volume={5}
              muted={false}
              playing={false}
              ref={playerRef}
              playsinline={true}
              light={thumbnail?.value?.src}
            />
          }
        </div>
      )}

      {shoudRenderYoutube && (
        <div className={`videoItem youtube`}>
          {
            <ReactPlayer
              url={`//www.youtube.com/embed/${videoYoutubeSource}`}
              loop={false}
              controls={true}
              volume={5}
              muted={false}
              playing={false}
              ref={playerRef}
              playsinline={true}
              light={thumbnail?.value?.src}
            />
          }
        </div>
      )}
    </div>
  );
};
export default HeaderBannerDigitalBankingComponent;
